export default __webpack_public_path__ + "static/media/img_affliate_bg_1.ef035b90.webp";